var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeleteItem(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ff7e74;}.cls-2{fill:#ffe9e9;}.cls-3{fill:#ff4a4a;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_210",
    "data-name": "Layer 210"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 98,
    y: 103,
    width: 405,
    height: 497,
    rx: 49.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 62.83,
    y: 361.04,
    width: 270.61,
    height: 52.26,
    rx: 26.13,
    transform: "translate(585.31 189.03) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 167.36,
    y: 361.04,
    width: 270.61,
    height: 52.26,
    rx: 26.13,
    transform: "translate(689.83 84.5) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 271.88,
    y: 361.04,
    width: 270.61,
    height: 52.26,
    rx: 26.13,
    transform: "translate(794.36 -20.02) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 244.02,
    y: 0.67,
    width: 117.3,
    height: 117.3,
    rx: 58.65
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25,
    y: 59,
    width: 550,
    height: 133,
    rx: 66.5
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteItem);
export default __webpack_public_path__ + "static/media/delete_item.55b8241a384f66eb719de7476313e6bb.svg";
export { ForwardRef as ReactComponent };